import { VersionsContext } from "common/contexts/VersionsContext";
import { useContext } from "react";

export function useVersions() {
  return useContext(VersionsContext);
}
